/**
 *
 * @param {bool} isApSecure - Comes from the secure_browser feature flag
 *
 * LDB is the respondus secure browser, this utility is meant to be used to determine
 * if the secure browser should be shown for AP
 *
 * Example: IsLdbEnabled(secure_browser)
 */
const IsLdbEnabled = (isApSecure) => {
  return isApSecure;
};

export default IsLdbEnabled;
